
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-qty-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(btn.dataset.qtyButton || 0);
      const min = Number(input.min || 0);
      input.value = Math.max(min, Number(input.value || 0) + step);
      const form = btn.closest('form');
      if (form && btn.closest('[data-cart-line]')) form.requestSubmit();
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const root = select.closest('[data-product-root]');
    if (!root) return;
    const price = root.querySelector('[data-product-price]');
    const add = root.querySelector('[data-add-to-cart]');
    const sync = () => {
      const opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (add) {
        const available = opt.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? add.dataset.availableText : add.dataset.soldoutText;
      }
    };
    select.addEventListener('change', sync); sync();
  });
});
